import React from "react";

function TelegramIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="20"
      fill="none"
      viewBox="0 0 24 20"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.037 8.48C8.24 5.78 12.374 3.999 14.443 3.138 20.351.68 21.578.253 22.378.24c.176-.003.57.04.825.247.215.175.274.41.303.576.028.166.063.543.035.838-.32 3.364-1.705 11.526-2.41 15.294-.298 1.594-.885 2.129-1.454 2.18-1.235.114-2.173-.816-3.37-1.6-1.872-1.227-2.93-1.991-4.747-3.189-2.1-1.384-.739-2.145.458-3.388.313-.325 5.756-5.276 5.862-5.725.013-.056.025-.266-.1-.376-.124-.11-.307-.073-.44-.043-.188.043-3.179 2.02-8.973 5.931-.849.583-1.618.867-2.307.852-.76-.016-2.22-.43-3.307-.782-1.332-.434-2.39-.662-2.298-1.398.048-.383.575-.775 1.582-1.175z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default TelegramIcon;
